import S_base from '@/services/wasaapi/__base';

export default {
  async create(data) {
    const res = await S_base.create({
      modelName: 'act',
      data,
    });
    return res;
  },
  async show(id) {
    const res = await S_base.show({
      modelName: 'act',
      modelId: id,
    });
    return res;
  },
};